import { connect } from 'react-redux';

import { StoreState } from '../../../../redux/reducers/store.types';
import { locateFile } from '../../../file-manager/redux/file-manager.actions';
import {
  cancelFilesUploadGroup,
  cancelFileUpload,
  closeOperationGroup,
  retryUploadOperations,
} from '../operation-groups.actions';

import { UploadGroup } from './upload-group';
import { getFileUploadOperationsForGroup } from './upload-group.selectors';

export interface OwnProps {
  groupId: string;
}

const mapStateToProps = (state: StoreState, ownProps: OwnProps) => ({
  uploadOperationsList: getFileUploadOperationsForGroup(state, ownProps),
});

const mapDispatchToProps = {
  closeGroup: closeOperationGroup,
  cancelAllUploads: cancelFilesUploadGroup,
  cancelFileUpload,
  locateFile,
  retryUploadOperations,
};

export const UploadGroupContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(UploadGroup);
